import { takeEvery } from 'redux-saga/effects';

import * as paymentMethodsActionTypes from 'store/modules/paymentMethods/actionTypes';
import { load } from './utils';

export default function* listenLoad() {
  yield takeEvery(paymentMethodsActionTypes.LOAD, load);
}
